<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :status="'APPLY'"
                :title="'방문예약 신청'"
            />
            <div class="content">
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            방문자 구분
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-select
                            placeholder="구분 선택"
                            v-model="visitor_category"
                            @change="clearChild"
                        >
                            <el-option
                                label="학부모"
                                :value="'PARENT'"
                                v-if="store.available_time && store.available_time.parent.available"/>
                            <el-option
                                label="외부인"
                                :value="'GUEST'"
                                v-if="store.available_time && store.available_time.guest.available" />
                        </el-select>
                    </div>
                </div>
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            방문 희망 시간
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-date-picker
                            class="h48"
                            type="date"
                            v-model="reserved_date"
                            placeholder="방문일자"
                            :clearable="false"
                            :editable="false"
                            :picker-options="{
                                disabledDate: handleDisableDate
                            }"
                        />
                        <el-time-select
                            class="h48"
                            id="time"
                            v-model="reserved_time"
                            :picker-options="{
                                start: getStartTime,
                                step: '00:10',
                                end: getEndTime,
                            }"
                            :clearable="false"
                            :editable="false"
                            placeholder="시간"
                        />
                    </div>
                </div>
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            방문할 선생님 성함
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-input v-model="reserved_teacher_name" class="h48"/>
                    </div>
                </div>
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            방문목적
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-input v-model="visit_purpose" class="h48"/>
                    </div>
                </div>
                <div class="input-area" v-if="visitor_category === 'PARENT'">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            자녀정보
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-select
                            placeholder="학년"
                            v-model="child_grade"
                        >
                            <el-option
                                v-for="(item, index) in getGrades"
                                :key="index"
                                :value="item"
                                :label="`${item}학년`"
                            />
                        </el-select>
                        <el-select
                            placeholder="반"
                            v-model="child_class"
                        >
                            <el-option
                                v-for="(item, index) in getClassrooms"
                                :key="index"
                                :value="item"
                                :label="`${item}반`"
                            />
                        </el-select>
                        <el-input class="h48" v-model="child_name" placeholder="이름"/>
                    </div>
                </div>
                <div class="input-area" v-if="visitor_category === 'PARENT'">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            자녀와의 관계
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-select
                            placeholder="선택"
                            v-model="child_relationship"
                        >
                            <el-option label="부" :value="'FATHER'" />
                            <el-option label="모" :value="'MOTHER'" />
                            <el-option label="기타" :value="'ETC'" />
                        </el-select>
                    </div>
                </div>
                <div class="submit-btn">
                    <button @click="handleSubmit">신청하기</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import { store } from "@/store";
import { format } from "@/util/dateformat";
import api from "@/api";
import { ERROR_TYPE } from "@/lib/type";

export default {
    name: "ReservationForm",
    components: { GlobalHeader },
    data: () => ({
        store,
        visitor_category: null,
        reserved_date: null,
        reserved_time: null,
        reserved_teacher_name: null,
        visit_purpose: null,
        child_grade: null,
        child_class: null,
        child_name: null,
        child_relationship: null,
    }),
    computed: {
        getStartTime() {
            if(this.visitor_category === "PARENT") {
                return store.available_time.parent.startTime.substring(0,5);
            } else if(this.visitor_category === "GUEST") {
                return store.available_time.guest.startTime.substring(0,5);
            } else {
                return null;
            }
        },
        getEndTime() {
            if(this.visitor_category === "PARENT") {
                return store.available_time.parent.endTime.substring(0,5);
            } else if(this.visitor_category === "GUEST") {
                return store.available_time.guest.endTime.substring(0,5);
            } else {
                return null;
            }
        },
        getGrades() {
            return store.classrooms
                .map(c => c.grade)
                .filter((value, index, self) => self.indexOf(value) === index);
        },
        getClassrooms() {
            return store.classrooms
                .filter(c => c.grade === this.child_grade)
                .map(c => c.className)
        }
    },
    methods: {
        async handleSubmit() {
            // validation
            if(!this.visitor_category) {
                this.$alert.danger({ message: '방문자 구분을 선택해주세요.' });
                return;
            }
            if(!this.reserved_date) {
                this.$alert.danger({ message: '방문희망 일자를 선택해주세요.' });
                return;
            }
            if(!this.reserved_time) {
                this.$alert.danger({ message: '방문희망 시간을 선택해주세요.' });
                return;
            }
            if(!this.reserved_teacher_name || this.reserved_teacher_name.length < 2) {
                this.$alert.danger({ message: '방문할 선생님의 성함을 2자 이상 입력해주세요.' });
                return;
            }
            if(!this.visit_purpose || this.visit_purpose < 5) {
                this.$alert.danger({ message: '방문 목적을 5자 이상 입력해 주세요.' });
                return;
            }
            if(
                this.visitor_category === "PARENT" && (
                    !this.child_class ||
                    !this.child_grade ||
                    (!this.child_name || this.child_name.length < 2)
                )
            ) {
                this.$alert.danger({ message: '자녀 정보를 정확히 입력해 주세요.' });
                return;
            }

            if(this.visitor_category === "PARENT" && !this.child_relationship) {
                this.$alert.danger({ message: '자녀와의 관계를 선택하세요.' });
                return;
            }

            try {
                const data = {
                    school_id: store.school.id,
                    user_type: store.auth.type,
                    token: store.auth.token,
                    visitor_name: store.visitor.name,
                    visitor_category: this.visitor_category,
                    reserved_at: format("yyyy-MM-DD", this.reserved_date) + ` ${this.reserved_time}:00`,
                    reserved_teacher_name: this.reserved_teacher_name,
                    visit_purpose: this.visit_purpose,
                    child_grade: this.child_grade,
                    child_class: this.child_class,
                    child_name: this.child_name,
                    child_relationship: this.child_relationship,
                };
                let response = await api.createReservation(data);

                if (response.result === "success") {
                    this.$router.push({ path: `/schools/${store.school.id}/visit/apply/success` });
                } else {
                    throw new Error(response.code);
                }
            } catch (e) {
                this.handleErrorMessage(e);
            }

        },
        handleDisableDate(date) {
            // 토, 일요일 제외
            if(date.getDay() === 0 || date.getDay() === 6) return true;

            // 오늘보다 이전 날짜 제외
            if(date.getTime() < (new Date().setHours(0, 0, 0, 0))) return true;

            for (const ed of store.exclusion_date) {
                let exclusion_start_date = new Date(`${ed.startDate} 00:00:00`);
                let exclusion_end_date = new Date(`${ed.endDate} 00:00:00`);

                if(date.getTime() >= exclusion_start_date.getTime() && date.getTime() <= exclusion_end_date.getTime()) {
                    return true;
                }
            }
        },
        handleErrorMessage(error) {
            let result = null;

            if (typeof error === "object") {
                result = ERROR_TYPE[error.message];
            } else {
                result = ERROR_TYPE[error];
            }

            const message = !result ? "알 수 없는 오류 발생" : result;

            this.$alert.danger({ message });
        },
        clearChild() {
            this.reserved_time = null;
            this.child_grade = null;
            this.child_class = null;
            this.child_name = null;
            this.child_relationship = null;
        }
    },
    mounted() {
        // 학교정보 없으면 초기화면으로 보냄
        if(!store.school.id) {
            this.$router.push({ path: `/schools/${this.$route.params.school}/visit` });
        }
    }
};
</script>

<style scoped lang="scss">

</style>